<template>
    <v-container class="pb-6">
        <Form
            :module="this.moduleObj"
            @saved="saved"
            :titlePrefix="$t('form.actions.edit')"
            :isEdit="true"
            v-if="this.moduleObj.plan"
        ></Form>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import Module from '@/models/plans/Module'
import Form from './Form'

export default {
    props: ['id', 'module'],

    data: () => {
        return {
            moduleObj: new Module(),
        }
    },

    components: {
        Form,
    },

    methods: {
        async getModule() {
            let res = await this.$http.get(
                `config-plans/${this.id}/module/${this.module}`,
            )

            this.moduleObj = this.moduleObj.respond(res.data)
        },

        saved() {
            this.$router.push({
                name: 'plans.module',
                params: { id: this.id },
            })
        },
    },

    created() {
        this.getModule()
    },
}
</script>
